import React, { useMemo, useState } from "react";
import { useDispatch } from "react-redux";

import posthog from "posthog-js";

import { addToCart, removeFromCart } from "@store/cart";

import Counter from "@components/common/Counter";
import Icon from "@components/common/Icon";

import type { Product } from "@typings/product/product";
import type { CartItemType } from "@typings/cart";

interface CartItemFooterProps {
  cartItem: Product;
  type: CartItemType;

  hideRemoveBtn?: boolean;
  hideCounter?: boolean;

  isTopDeal?: boolean;
}

const CartItemFooter = ({
  cartItem,
  type,
  hideRemoveBtn,
  hideCounter,
  isTopDeal,
}: CartItemFooterProps) => {
  const { item, configuration } = cartItem;
  const isFree = useMemo(() => item.category.name === "Free Gift", [item]);
  const [localQuantity, setLocalQuantity] = useState(configuration.quantity);

  const dispatch = useDispatch();

  const handleAddToCart = () => {
    dispatch(
      addToCart({
        cartItems: [
          {
            ...cartItem,
            configuration: {
              ...configuration,
              quantity: isTopDeal ? localQuantity : configuration.quantity,
            },
          },
        ],
      })
    );

    if (typeof window !== "undefined") {
      posthog.capture("Add to cart", {
        product_id: item.id,
        product_name: item.name,
      });
    }
  };

  const handleRemoveFromCart = () => {
    dispatch(removeFromCart({ cartItems: [cartItem] }));

    if (typeof window !== "undefined") {
      posthog.capture("Remove from cart", {
        product_id: item.id,
        product_name: item.name,
      });
    }
  };

  const handleChangeQuantity = (newQuantity: number) => {
    dispatch(
      addToCart({
        cartItems: [
          {
            ...cartItem,
            configuration: {
              ...configuration,
              quantity: newQuantity,
            },
          },
        ],
      })
    );
  };

  return type === "ADD" ? (
    <div className="cart-item__footer">
      {!isFree && !hideCounter && (
        <Counter
          className="cart-item__counter"
          count={isTopDeal ? localQuantity : configuration.quantity}
          setCount={isTopDeal ? setLocalQuantity : handleChangeQuantity}
        />
      )}

      <button onClick={handleAddToCart} type="button" className="cart-item__add">
        Add
      </button>
    </div>
  ) : (
    <div className="cart-item__actions">
      {!isFree && !hideCounter && (
        <Counter
          className="cart-item__counter"
          count={configuration.quantity}
          setCount={handleChangeQuantity}
        />
      )}

      {!isFree && (
        <React.Fragment>
          <div className="cart-item__total-price-wrapper">
            <span className="cart-item__total-quantity">{configuration.quantity} x </span>
            <span className="cart-item__total-price">${configuration.price}</span>
            {configuration.oldPrice !== configuration.price && (
              <span className="cart-item__total-old-price">${configuration.oldPrice}</span>
            )}
          </div>
        </React.Fragment>
      )}
      {/* {!hideRemoveBtn && !isFree && (
        <button onClick={handleRemoveFromCart} type="button" className="cart-item__remove">
          <Icon width={16} height={16} name="trash" />
          <span>Remove</span>
        </button>
      )} */}
    </div>
  );
};

export default CartItemFooter;
